import { render, staticRenderFns } from "./ModeratorRootView.vue?vue&type=template&id=6af84046"
import script from "./ModeratorRootView.vue?vue&type=script&lang=js"
export * from "./ModeratorRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports